import { cn } from '@/utils/tailwind.util';
interface SkeletonProps {
  variant?: 'text' | 'rectangle';
  width?: number | string;
  height?: number | string;
  className?: string;
}
export function Skeleton({
  variant = 'rectangle',
  width,
  height,
  className
}: SkeletonProps) {
  const baseClasses = 'animate-pulse bg-[rgba(28,27,31,0.04)] rounded-md';
  const variantClasses = {
    text: 'h-4 rounded-md',
    rectangle: 'rounded-lg'
  };
  const style = {
    ...(width && {
      width: typeof width === 'number' ? `${width}px` : width
    }),
    ...(height && {
      height: typeof height === 'number' ? `${height}px` : height
    })
  };
  return <div className={cn(baseClasses, variantClasses[variant], className)} style={style} data-sentry-component="Skeleton" data-sentry-source-file="Skeleton.tsx" />;
}